"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderValidationMessage = void 0;
var _Localization = require("../Localization");
var _defaultTranslations = require("../constants/defaultTranslations");
var _TranslationKey = require("../models/TranslationKey");
var _jsxRuntime = require("react/jsx-runtime");
const renderValidationMessage = (error, validation) => {
  let customMessage = error.message;
  if (error.type === 'required') {
    customMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _defaultTranslations.defaultTranslations.validationRequired,
      id: _TranslationKey.TranslationKey.validationRequired
    });
  }
  if (error.type === 'maxLength') {
    customMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _defaultTranslations.defaultTranslations.validationMaxLength,
      id: _TranslationKey.TranslationKey.validationMaxLength,
      values: {
        max: validation?.maxLength
      }
    });
  }
  if (error.type === 'minLength') {
    customMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _defaultTranslations.defaultTranslations.validationMinLength,
      id: _TranslationKey.TranslationKey.validationMinLength,
      values: {
        min: validation?.minLength
      }
    });
  }
  if (error.type === 'pattern') {
    customMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      defaultMessage: _defaultTranslations.defaultTranslations.validationRegex,
      id: _TranslationKey.TranslationKey.validationRegex
    });
  }
  return customMessage;
};
exports.renderValidationMessage = renderValidationMessage;
//# sourceMappingURL=getValidationMessage.js.map